import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gasbuddy/react-components';
import styles from './styles.css';

const { canEditStationFuelPrices } = require('../../../../lib/permissions').default;

const NoPrice = ({ onUpdatePriceClick }) => (
  <div>
    <div className={styles.priceItemPrice}>--</div>
    {canEditStationFuelPrices() && (
    <Button
      className={styles.priceRowUpdatePrice}
      onClick={onUpdatePriceClick}
      type="button"
      rounded
      color="red"
    >
      Update Price
    </Button>
    )}
  </div>
);

NoPrice.propTypes = {
  onUpdatePriceClick: PropTypes.func.isRequired,
};

export default NoPrice;
